export default class FxPromise
{
    static resolve(value)
    {
        return Promise.resolve(value);
    }

    static then(callback)
    {
        return Promise.resolve().then(callback);
    }

    static foreach(datas, callback)
    {
        let result, i = 0, length = datas.length;
        return execute();

        function execute()
        {
            if(i >= length)
                return FxPromise.resolve(datas);
            return FxPromise.then(() =>
            {
                result = callback(datas[i], i);
                return result;
            }).
            then(() =>
            {
                i++;
                if(result === false)
                {
                    return datas;
                } else
                {
                    return execute();
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/fx/Promise.js